// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".desktop-container {\n  width: 100vw;\n}\n.desktop-card {\n  padding: 0.75rem;\n  box-shadow: none;\n}\n#desktop-main {\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
